import { Record, Map as ImmutableMap } from 'immutable';
import AssociationSpec from 'automation-ui-associations/records/AssociationSpec';
import * as TargetPropertySourceTypes from 'automation-ui-action-features/object-type-properties/TargetPropertySourceTypes';
import * as TargetPropertyKeys from 'automation-ui-action-features/object-type-properties/TargetPropertyKeys';
export default class TargetProperty extends Record({
  [TargetPropertyKeys.SOURCE]: TargetPropertySourceTypes.OBJECT,
  [TargetPropertyKeys.PROPERTY_NAME]: null,
  [TargetPropertyKeys.ASSOCIATION_SPEC]: null
}, 'TargetProperty') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    const associationSpecRaw = propMap.get('associationSpec');
    super(propMap.set('associationSpec', associationSpecRaw ? new AssociationSpec(associationSpecRaw) : null));
  }
  getSource() {
    return this[TargetPropertyKeys.SOURCE];
  }
  getPropertyName() {
    return this[TargetPropertyKeys.PROPERTY_NAME];
  }
  setPropertyName(propertyName) {
    return this.set(TargetPropertyKeys.PROPERTY_NAME, propertyName);
  }
  getAssociationSpec() {
    return this[TargetPropertyKeys.ASSOCIATION_SPEC];
  }
  setAssociationSpec(associationSpec) {
    return this.set(TargetPropertyKeys.ASSOCIATION_SPEC, associationSpec);
  }
}